"use client"

import { useState } from "react"
import cn from "classnames"

import type { AccordionItem } from "~/components/elements/Accordion/Accordion.interface"
import { AnimateText } from "~/components/elements/AnimateText/AnimateText"
import { FadeIn } from "~/components/elements/FadeIn/FadeIn"
import { HtmlRenderer } from "~/components/primitives/HtmlRenderer"
import { Icon } from "~/components/primitives/icon"

import s from "./Accordion.module.scss"

type AccordionProps = {
  accordionItems: AccordionItem[]
  className?: string
}

export const Accordion = ({ accordionItems, className }: AccordionProps) => {
  const [selectedAccordionItem, setSelectedAccordionItem] = useState(-1)

  const toggleOpenAccordion = function (index: number) {
    if (index === selectedAccordionItem) {
      setSelectedAccordionItem(-1)
    } else {
      setSelectedAccordionItem(index)
    }
  }

  return (
    <div
      className={cn(s.accordion, "default-grid", className)}
      data-element="accordion"
    >
      {accordionItems.map((accordion, index) => (
        <FadeIn
          className={cn(s.accordionItemWrapper, "default-grid")}
          key={accordion.title}
        >
          <div
            className={cn(
              s.accordionItem,
              index === selectedAccordionItem && s.open,
            )}
          >
            <button
              type="button"
              className={s.accordionItemHeader}
              onClick={() => toggleOpenAccordion(index)}
            >
              <AnimateText element="div" className={s.headline}>
                <HtmlRenderer html={accordion.title} />
              </AnimateText>
              <Icon
                width="20"
                height="20"
                id="accordion-toggle"
                className={s.buttonIcon}
              />
            </button>
            <div className={s.accordionBodyWrapper}>
              <HtmlRenderer
                element="div"
                className={s.accordionBody}
                html={accordion.copy}
              />
            </div>
          </div>
        </FadeIn>
      ))}
    </div>
  )
}
